import React, {useEffect, useState} from "react";
import FindBookings from "./components/FindBookings";
import FindUser from "./components/FindUser";
import ReservationSelect from "./components/ReservationSelect";
import UserSelect from "./components/UserSelect";
import {reservationsActions} from "inbooma-api";
import {Biscuit} from "../../../../utils";
import SupportItem from "./SupportItem";

const SupportView = (props) => {
    const {
        client,
        clientId,
        dispatch,
        language,
        users,
        setUsers,
        user,
        setUser,
        reservations,
        setReservations,
        reservation,
        setReservation,
        reservationQuery,
        setReservationQuery,
        userQuery,
        setUserQuery} = props;

    const [reservationsPending,setReservationsPending] = useState(false);
    const [usersPending,setUsersPending] = useState(false);

    useEffect(() => {
        if(user !== null && !usersPending){
            //get bookings from user
            dispatch(reservationsActions.getReservations(
                {
                    token: Biscuit.get('token'),
                    suffix:"",
                    filter: {
                        'user_id': user.id,
                        'client_id': clientId,
                        'find': "full",
                        sort: "begin",
                        direction: "desc"
                    },
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setReservationsPending(true);
        }
    },[user]);



    return ( <>
    <div className="inb-c-item inb-c-item--from row">
        <div className="small-6 medium-12 column">
            <FindUser
                clientId={clientId}
                dispatch={dispatch}
                setUser={setUser}
                user={user}
                setUsersPending={setUsersPending}
                setUsers={setUsers}
                usersPending={usersPending}
                language={language}
                setUserQuery={setUserQuery}
                setReservationQuery={setReservationQuery}
                userQuery={userQuery}
                setReservation={setReservation}
                setReservations={setReservations}
            />
            <span style={{float:"left",padding:"10px"}}>oder</span>
            <FindBookings
                clientId={clientId}
                dispatch={dispatch}
                reservation={reservation}
                setReservation={setReservation}
                setReservations={setReservations}
                reservationsPending={reservationsPending}
                setReservationsPending={setReservationsPending}
                language={language}
                setUserQuery={setUserQuery}
                setReservationQuery={setReservationQuery}
                reservationQuery={reservationQuery}
                setUsers={setUsers}
                setUser={setUser}
            />
        </div>
    </div>
        {reservations !== null && !reservationsPending && reservation === null &&
            <ReservationSelect
                reservations={reservations}
                setReservation={setReservation}
                language={language}
            />
        }
        {users !== null && !usersPending && user === null &&
            <UserSelect
                users={users}
                setUser={setUser}
                language={language}
            />
        }
        {reservation !== null && <>
            <SupportItem
                reservation={reservation}
                dispatch={dispatch}
                language={language}
                client={client}
                />
        </>}
        {(reservationsPending || usersPending) &&<>
            <div className="inb-c-item inb-c-item--from row" key="noid">
                <div className="small-12 medium-12 column" style={{textAlign:"center"}}>
                    <span><img alt="RollingLoader" className="rollingLoader colorize-black"
                               src={"assets/img/rolling_loader.svg"}/> </span>
                </div> </div>
        </>}
    </>);
};

export default SupportView;